import { matchPath, useLocation } from 'react-router-dom';
import useNoindexMeta from '../hooks/useNoindexMeta';

const PRIVATE_LANGUAGE_PATHS = [
  '/:lang/onboarding/*',
  '/:lang/checkout',
  '/:lang/speaking-minutes',
  '/:lang/community',
  '/:lang/dashboard',
  '/:lang/vocabulary-review/session',
  '/:lang/settings',
  '/:lang/achievements',
  '/:lang/account-deletion',
  '/:lang/library/design-lab',
  '/:lang/library/collection/:seriesId/:storyId/read',
  '/:lang/language-hub/admin',
  '/:lang/admin/*',
  '/:lang/__protected/*',
];

export function isPrivateLanguagePath(pathname) {
  return PRIVATE_LANGUAGE_PATHS.some((path) => matchPath({ path, end: true }, pathname));
}

// Keep metadata outside page auth/loading gates, including the outer onboarding routes.
export default function PrivateLanguageRouteMeta({ children }) {
  const { pathname } = useLocation();
  useNoindexMeta(isPrivateLanguagePath(pathname));
  return children;
}
